export const MENU_TYPES = {
  preorder: 'Pre-Order',
  day_of_event: 'Day of Event',
  coffee: 'Coffee Cart',
  cordial: 'Cordial Cart',
  dessert: 'Dessert Cart',
  restock: 'Restock Order',
}

export const SHOULD_VISIT_MENU_TYPES = [ 'coffee', 'cordial', 'dessert' ]
